import isEmpty from 'lodash/isEmpty';

import {
  removeQuoteFieldsForClone,
  removeQuoteLineFieldsForClone,
} from '../../quote-editor/utils/transform-for-patch';
import api from '../../REST/api';
import storedUserInfo from '../../utils/session-data/user-info';
import { transformForPatch as transformOpportunityForPatch } from '../transform-opportunity-helpers';

const currentUserInfo = storedUserInfo.get();

export default async function postOpportunityAndPrimaryQuote(
  oldOpportunity,
  expectedRevenueFields,
  merchants,
) {
  const {
    expectedRevenueMediaManaged,
    expectedRevenueMediaSelfService,
    expectedRevenueCreative,
    expectedRevenueCI,
    expectedRevenueOther,
  } = expectedRevenueFields.expectedRevenueSubFields;
  const { expectedRevenue } = expectedRevenueFields;
  const opportunityData = {
    ...(await transformOpportunityForPatch(oldOpportunity, {}, merchants)),
    stage: 'Pitched',
    name: `Copy of ${oldOpportunity.name}`,
    expectedRevenue,
    expectedRevenueMediaManaged,
    expectedRevenueMediaSelfService,
    expectedRevenueCreative,
    expectedRevenueCI,
    expectedRevenueOther,
  };
  opportunityData.agreementOpportunities = [];
  opportunityData.ownerId = currentUserInfo.id;

  const newOpportunity = await api.addOpportunity({
    data: opportunityData,
  });

  if (oldOpportunity.primaryQuoteId) {
    const oldQuote = await api.getQuote({
      id: oldOpportunity.primaryQuoteId,
    });

    const {
      billableBudgetMediaExternal,
      billableBudgetMediaInternal,
      billableBudgetMediaWKZ,
      billableBudgetCreativeExternal,
      billableBudgetCreativeInternal,
      billableBudgetCreativeWKZ,
      billableBudgetCIExternal,
      billableBudgetCIInternal,
      billableBudgetCIWKZ,
      billableBudgetOtherExternal,
      billableBudgetOtherInternal,
      billableBudgetOtherWKZ,
    } = oldQuote;

    const quoteData = {
      ...removeQuoteFieldsForClone(oldQuote),
      opportunityId: newOpportunity.id,
    };

    const newQuote = await api.addQuote({
      data: quoteData,
      search: { is_clone: true },
    });

    if (
      !isEmpty(oldQuote.genders) ||
      !isEmpty(oldQuote.categories) ||
      !isEmpty(oldQuote.quoteLines)
    ) {
      let quoteLines = [];
      if (!isEmpty(oldQuote.quoteLines)) {
        quoteLines = oldQuote.quoteLines.map(line => {
          /* eslint-disable no-param-reassign */
          line.freeService = 0;
          return removeQuoteLineFieldsForClone(line);
        });
      }
      // billable field values are added since when the user sets expectedRevenue values, the BE returns different response
      // on quote creation due to the RECO feature. Hence to keep it synced this has been added.
      await api.patchQuote({
        id: newQuote.id,
        data: {
          billableBudgetMediaExternal,
          billableBudgetMediaInternal,
          billableBudgetMediaWKZ,
          billableBudgetCreativeExternal,
          billableBudgetCreativeInternal,
          billableBudgetCreativeWKZ,
          billableBudgetCIExternal,
          billableBudgetCIInternal,
          billableBudgetCIWKZ,
          billableBudgetOtherExternal,
          billableBudgetOtherInternal,
          billableBudgetOtherWKZ,
          categories: oldQuote.categories,
          commercialIncentive: '',
          genders: oldQuote.genders,
          quoteLines,
        },
        search: { is_clone: true },
      });
    }

    await api.patchOpportunity({
      id: newOpportunity.id,
      data: { primaryQuoteId: newQuote.id },
    });
  }

  return newOpportunity;
}
